import React from 'react'

export default function MyProfile() {
  return (
    <div>MyProfile</div>
  )
}
